import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    modalContainer: {
        "& .mantine-Modal-inner": {
            overflowY: "auto",
        },
    },
    modalContent: {
        display: "flex",
        width: "45rem",
        height: "38rem",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "9.5rem",
        borderRadius: theme.spacing.sm,
        border: `1px solid ${theme.colors.gray[2]}`,
        boxShadow: "0px 8px 24px -8px rgba(0, 0, 0, 0.16)",
    },

    modalHeader: {
        display: "flex",
        padding: `${theme.spacing.md} ${theme.spacing.lg} ${theme.spacing.md} ${theme.spacing.xl}`,
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "stretch",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
    },

    modalTitle: {
        color: theme.colors.gray[9],
        textAlign: "center",
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontSize: rem(20),
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
    },

    modalCloseButton: {
        height: "2.5rem",
        width: "2.5rem",
    },

    modalBody: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        flex: "1 0 0",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
        alignSelf: "stretch",
        overflowY: "scroll",
        height: "100%",
        padding: "0 1.5rem",

        "&:hover::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.3)",
            borderRadius: "1rem",
            border: "0.125rem solid rgba(0,0,0,.0)",
            backgroundClip: "padding-box",
            padding: "0.125rem",
            width: rem(12),
        },

        "&::-webkit-scrollbar-thumb": {
            width: rem(8),
        },

        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },

        "&::-webkit-scrollbar": {
            width: rem(8),
            background: "transparent",
        },
    },

    content: {
        display: "flex",
        width: "100%",
        height: "100%",
        padding: "1rem 0 0 0",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: rem(24),
    },

    modalFlex: {
        display: "flex",
        padding: "0.75rem 0",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: rem(24),
        minWidth: rem(300),
    },

    modalButtons: {
        display: "flex",
        padding: `${theme.spacing.md} ${theme.spacing.xl}`,
        justifyContent: "flex-end",
        alignItems: "flex-start",
        gap: theme.spacing.sm,
        alignSelf: "stretch",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
    },

    cancelButton: {
        display: "flex",
        height: "2.5rem",
        padding: "0.75rem 1rem",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.375rem",
        borderRadius: "0.25rem",
        border: `1px solid ${theme.colors.gray[3]}`,
    },

    submitButton: {
        display: "flex",
        height: "2.5rem",
        padding: "0.75rem 1rem",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.375rem",
        background: theme.colors.violet[7],
        color: theme.colors.gray[1],
    },

    selects: {
        gap: rem(6),
        color: theme.colors.gray[7],
        fontSize: rem(14),
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
        marginRight: rem(4),
    },

    stackRow: {
        display: "flex",
        flexDirection: "row",
        gap: rem(16),
        width: "100%",
    },

    stack: {
        display: "flex",
        flexDirection: "column",
        gap: rem(24),
        width: "100%",
    },

    stackFullCol: {
        display: "flex",
        gap: rem(8),
        alignItems: "end",
        width: "100%",
    },

    contactButton: {
        flex: 1,
    },

    stackCol: {
        display: "flex",
        flexDirection: "column",
        gap: rem(24),
        width: "100%",
    },

    rowSelectOption: {
        display: "column",
    },

    colSelect: {
        flexGrow: 1,
    },

    colViewProfile: {
        alignSelf: "flex-end",
        margin: rem(11),
    },
}))
